import React from 'react'
import { Box } from '@node-space/ui-components'
import { ContactsSearch } from 'components/Contacts/ContactsSearch'
import { ContactAtomType } from 'types/atoms/atom.contacts'

interface ContactAssignSearchProps {
  atomType: ContactAtomType
}

export const ContactAssignSearch = ({ atomType }: ContactAssignSearchProps) => {
  return (
    <Box width="full">
      <ContactsSearch atomType={atomType} />
    </Box>
  )
}
